import { Component, input, signal } from "@angular/core";
import { IMenuItemModel } from "@models/core/menu";
import { animate, style, transition, trigger } from "@angular/animations";

@Component({
  selector: "app-toolbar-menu-item",
  templateUrl: "./toolbar-menu-item.component.html",
  styleUrl: "./toolbar-menu-item.component.scss",
  standalone: false,
  host: {
    class: "contents",
  },
  animations: [
    trigger("itemState", [
      transition("* => open", [
        style({ opacity: 0, transform: "scale(0.5)", left: "50%" }),
        animate(
          "150ms cubic-bezier(0, 0, 0.2, 1)",
          style({ opacity: 1, transform: "scale(1)", left: "*" }),
        ),
      ]),
      transition("* => close", [
        animate("0ms", style({ opacity: 0, transform: "scale(0)", left: "0" })),
      ]),
    ]),
  ],
})
export class ToolbarMenuItemComponent {
  item = input<IMenuItemModel>();
  last = input<boolean>();

  readonly state = signal<string>("close");

  setState(state: string) {
    this.state.set(state);
  }
}
